import { z } from 'zod';
import { DISCREPANCY_SCOPES } from './discrepancy.js';
export const createCommentSchema = z.object({
    typeId: z.string({ required_error: 'Type de commentaire requis' }).uuid('Type inconnu'),
    texte: z
        .string({ required_error: 'Le commentaire ne peut pas être vide' })
        .trim()
        .min(1, 'Le commentaire ne peut pas être vide')
        .max(2000, 'Le commentaire ne doit pas dépasser 2 000 caractères'),
});
const libelleSchema = z
    .string({ required_error: 'Libellé requis' })
    .trim()
    .min(1, 'Libellé requis')
    .max(60, 'Le libellé ne doit pas dépasser 60 caractères');
export const createCommentTypeSchema = z.object({
    libelle: libelleSchema,
});
/**
 * Modification d'un type : libellé et activation.
 *
 * Désactiver **retire de la liste de saisie**, rien de plus : les commentaires
 * déjà écrits gardent leur type. Sinon l'historique se réécrirait tout seul, et
 * un dossier relu six mois plus tard ne dirait plus ce qu'il disait.
 */
export const updateCommentTypeSchema = z
    .object({
    libelle: libelleSchema.optional(),
    actif: z.boolean().optional(),
})
    .refine((v) => v.libelle !== undefined || v.actif !== undefined, {
    message: 'Rien à modifier',
});
/** Adresse d'un fil : la clé suivie, pas l'occurrence d'écart. */
export const commentScopeSchema = z.object({
    maille: z.enum(DISCREPANCY_SCOPES),
    cle: z.string().trim().min(1).max(120),
});
//# sourceMappingURL=comment.js.map